import React from "react";
import { TextField, Grid } from "@mui/material";

export default function FootballGameConfig({
  gameConfig,
  setGameConfig,
  loading = false,
  gameProvider,
}) {
  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name.startsWith("entry")) {
      const entryIndex = parseInt(name.replace("entry", "")) - 1;
      const newEntries = [...(gameConfig.entries || [])];
      newEntries[entryIndex] = parseInt(value) || 0;
      setGameConfig({
        ...gameConfig,
        entries: newEntries,
      });
    } else {
      setGameConfig({
        ...gameConfig,
        [name]: value,
      });
    }
  };

  return (
    <Grid container spacing={3}>
      {gameConfig &&
        gameConfig.entries &&
        gameConfig.entries.map((entry, index) => (
          <Grid item xs={3} key={`entry-${index}`}>
            <TextField
              name={`entry${index + 1}`}
              label={`Entry ${index + 1}`}
              fullWidth
              value={gameConfig.entries[index] || ""}
              onChange={handleInputChange}
              variant="outlined"
              disabled={loading}
              type="number"
            />
          </Grid>
        ))}

      <Grid item xs={6}>
        <TextField
          name="multplier"
          label="Multiplier"
          fullWidth
          value={gameConfig.multplier}
          onChange={handleInputChange}
          variant="outlined"
          disabled={loading}
          type="number"
          step="0.1"
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          name="winProbability"
          label="Win Probability"
          fullWidth
          value={gameConfig.winProbability}
          onChange={handleInputChange}
          variant="outlined"
          disabled={loading}
        />
      </Grid>
    </Grid>
  );
}
